import Button from "@/components/Button";

export default function ProjectCard({
  image,
  title,
  description,
  tags = [],
  live,
  repo,
  onClick,
}) {
  return (
    <div
      className="
        group relative overflow-hidden rounded-2xl
        border border-white/10
        bg-[color-mix(in_oklab,#fff_8%,transparent)]
        dark:bg-[color-mix(in_oklab,#000_26%,transparent)]
        backdrop-blur-md
        shadow-[inset_0_0_0_1px_rgba(255,255,255,.05)]
        hover:shadow-[inset_0_0_0_1px_rgba(255,255,255,.08),0_8px_24px_rgba(0,0,0,.20)]
        transition-all
      "
    >
      {/* Media: safer handling for various aspect ratios + graceful fallback */}
      <div className="relative w-full overflow-hidden bg-[color-mix(in_oklab,#000_40%,transparent)]">
        {/* Layout stabilizer */}
        <div className="aspect-video sm:aspect-[16/9] md:aspect-[16/9]" />
        {image ? (
          <img
            src={image}
            alt={title}
            className="absolute inset-0 h-full w-full object-contain bg-[color-mix(in_oklab,#111_60%,transparent)] transition-transform duration-500 group-hover:scale-[1.01]"
            loading="lazy"
            referrerPolicy="no-referrer"
            onError={(e) => {
              e.currentTarget.style.display = 'none';
              const fallback = e.currentTarget.nextElementSibling;
              if (fallback) fallback.classList.remove('hidden');
            }}
          />
        ) : null}

        {/* Fallback gradient or when image fails */}
        <div className={`absolute inset-0 ${image ? 'hidden' : ''} bg-gradient-to-tr from-neon-mint/20 via-neon-pink/20 to-neon-violet/20`} />
      </div>

      <div className="p-5">
        <h3 className="font-display text-xl">{title}</h3>
        <p className="mt-2 text-sm text-gray-600 dark:text-gray-300">{description}</p>

        {tags.length > 0 && (
          <div className="mt-3 flex flex-wrap gap-2">
            {tags.map((t) => (
              <span
                key={t}
                className="rounded-full border border-white/10 bg-white/5 px-2.5 py-1 text-xs text-gray-700 dark:text-gray-300"
              >
                {t}
              </span>
            ))}
          </div>
        )}

        {/* Subtle action box */}
        <div className="mt-5 flex items-center gap-3">
          {live && (
            <span
              className="
        inline-flex rounded-lg p-1
        bg-[color-mix(in_oklab,#fff_6%,transparent)]
        dark:bg-[color-mix(in_oklab,#000_22%,transparent)]
        shadow-[inset_0_0_0_1px_rgba(255,255,255,.06)]
      "
            >
              <Button
                as="a"
                href={live}
                target="_blank"
                rel="noreferrer"
                variant="solid"
                size="sm"
              >
                Live
              </Button>
            </span>
          )}

          {repo && (
            <Button as="a" href={repo} target="_blank" rel="noreferrer" variant="outline" size="sm">
              Code
            </Button>
          )}

          {onClick && (
            <Button onClick={onClick} variant="ghost" size="sm">
              Case study
            </Button>
          )}
        </div>

      </div>
    </div>
  );
}